/** @format */

import React from 'react';
import { Modal, Header, Divider, Grid, Form, Icon } from 'semantic-ui-react';

const ArchiveModal = ({ open, onSubmit, toggleModal, loading }) => {
  return (
    <Modal open={open}>
      <Modal.Content>
        <Header className="modal-header" as="h3">
          <small>Sicuro di voler archiviare queste richieste?</small>
        </Header>
        <Divider />
        <Form onSubmit={onSubmit}>
          <Grid columns="2">
            <Grid.Row>
              <Grid.Column textAlign="center">
                <Form.Button fluid type="button" onClick={toggleModal}>
                  Chiudi
                </Form.Button>
              </Grid.Column>
              <Grid.Column textAlign="center">
                <Form.Button type="submit" fluid color="red">
                  {loading ? <Icon name="spinner" loading /> : 'Archivia'}
                </Form.Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
      </Modal.Content>
    </Modal>
  );
};

export default ArchiveModal;
